<template>
  <!-- page container  -->
  <div>
    <div id="page-container  container mx-auto ">
      <!-- main contents wraper data goes here -->
      <div id="content-wrap  ">
        <div class="flex">
          <!-- start of main contents -->
          <div
            class="
              w-full
              h-full
              overflow-y-auto
              scrol-y-body
              invisible-scrollbar
              max-h
              el
            "
            id="main"
          
          >
            <div class="w-full h-full mb-24 relative" >
              <button
                class="
                  px-2
                  py-1.5
                  rounded-md
                  bg-pink-600
                  absolute
                  top-3
                  left-24
                  z-40
                  text-gray-200
                "
                v-if="isRefresh"
                @click="update"
              >
                تحديث الصفخة
              </button>

              <!-- vue router full path -->
              <router-view :key="$route.fullPath" />
            </div>
          </div>

          <!-- end of main contents -->

          <!-- start of sidebar nav -->
          <nav-bar class="hidden" />

          <!-- end of sidebar nav -->
        </div>
        <div v-if="getIsPlaying && !getRedirectStatus && trackData.length > 0">
          <audio-player
            :audios="trackData"
            :currentINDEX="currentIndex"
            :artist="getArtistData"
            :siPlaying="getIsPlaying"
          />
        </div>
        <div v-show="getRouteName">
          <mobile-menu />
        </div>
      </div>
      <!-- footer slots -->

      <!-- end of footer slots -->
    </div>
  </div>
</template>
<script>
import AudioPlayer from "./components/player/AudioPlayer.vue";
import MobileMenu from "./components/partials/MobileMenu.vue";
import NavBar from "./components/partials/NavBar.vue";
import { useTracksStore } from "@/stores/tracks";
import { mapState, mapActions } from "pinia";
export default {
  components: {
    NavBar,
    MobileMenu,
    AudioPlayer,
  },
  data() {
    return {
      currentIndex: 2,
      registration: null,
      isRefresh: false,
      refreshing: false,
      showMobileMenu: true,
    };
  },
  mounted(){
 
  },
  computed: {
    ...mapState(useTracksStore, [
      "tracksData",
      "trackData",
      "getIsPlaying",
      "getCurrentId",
      "getArtistData",
      "getRedirectStatus",
    ]),
    getRouteName() {
      if (this.$route.name === "login" || this.$route.name === "subscribe") {
        return false;
      } else {
        return true;
      }
      // return true
    },
  },
  watch: {
    getIsPlaying: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.getCureentIndex(this.getCurrentId);
        }
      },
    },
    getRedirectStatus: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$router.push({ name: "subscribe" });
        }
      },
    },
  },
  methods: {
    ...mapActions(useTracksStore, ["showTracksData"]),
   
    getCureentIndex(getCurrentId) {
      this.currentIndex = this.trackData.findIndex(
        (track) => track.id == getCurrentId
      );
    },
    appUpdateUI(e) {
      this.registration = e.detail;
      this.isRefresh = true;
    },
    update() {
      this.isRefresh = false;
      if (this.registration || this.registration.waiting) {
        this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    },
  },
  async created() {
    try {
      await this.showTracksData();
    } catch (e) {
      console.log(e);
    }

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },
};
</script>
  
      
  

<style>
@import url("https://fonts.googleapis.com/css2?family=Tajawal:wght@300;400&display=swap");

.text-color {
  color: #9d2890;
}
.btn-color {
  background-color: #9d2890;
}
.bg-nava-a {
  background-color: #c43670;
}
.text-nav-a {
  color: #c43670 !important;
}

.border-color {
  border-color: #c43670 !important;
}
.btn-color {
  background-color: #c43670 !important;
}
.order-btn {
  background-color: #191a2c;
}
.body-bg {
  background-color: #191a2c;
}
.card-bg {
  background-color: #15182b;
}
.btn-color-orange {
  background-color: #d5573b;
}
#page-container {
  position: relative;
  max-height: 100vh;
}

.scrol-y-body {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}

.invisible-scrollbar::-webkit-scrollbar {
  display: none;
}

*:focus,
:active {
  outline: 0 !important;
}

html {
  height: 100%;
}
body {
  max-height: 100%;
}
a:focus {
  outline: 0;
}

.bg-shimmer {
  background: gray;
}
.shimmer {
  color: grey;

  -webkit-mask: linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300%
    100%;
  background-repeat: no-repeat;
  animation: shimmer 2.5s infinite;
  font-size: 50px;
}

@keyframes shimmer {
  100% {
    -webkit-mask-position: left;
  }
}

.max-h{
  max-height: 100vh;
}
@media screen and (max-width: 960px) {
  .max-h{
  max-height: 90vh;
}

}
</style>
